module.exports = __webpack_public_path__ + "static/media/tehnobank.6732d67a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/tehnobank.png
// module id = 318
// module chunks = 0